<template>
  <div class="container-fluid" v-if="school && department && program">
    <div class="row justify-content-between">
      <div class="col">
        <h4>Улиралын дүн - {{ department.startYear }}, {{department.name}}{{ program.name }}</h4>
      </div>
    </div>
    <div class="container-fluid p-0">
      <div class="card shadow-sm my-4">
        <div class="card-header py-3">
          <div class="d-flex justify-content-between">
            <h6 class="m-0 font-weight-bold text-primary">
              Хичээлийн жагсаалт
            </h6>
            <h6>
              Xичээлийн тоо:
              <span class="text-primary font-weight-bold">{{
                lessonCategoriesInvolvedListData.length
              }}</span>
              , Xичээлийн тоо (Группуудыг тусад нь тооцвол):
              <span class="text-primary font-weight-bold">{{
                classLessons.length
              }}</span>
              , Сурагчийн тоо:
              <span class="text-primary font-weight-bold">{{
                students.length
              }}</span>
            </h6>

            <div class="d-flex">
              <label>
                <input
                  type="checkbox"
                  style="transform: scale(2)"
                  v-model="calculateSumme"
                />
                <span
                  class="ml-3 mr-4"
                  style="font-weight: bold; font-size: 14pt"
                  >Түвшин тооцоолоx</span
                >
              </label>
              <button
                class="btn btn-sm btn-danger"
                @click="handleDownload"
                v-if="!loading"
              >
                Export
              </button>
              <button
                class="btn btn-sm btn-primary"
                @click="_changeLessonMetaInfo"
                v-if="lessonInfoDetailed"
              >
                Дэлгэрэнгүй
              </button>
              <button
                class="btn btn-sm btn-primary"
                @click="_changeLessonMetaInfo"
                v-else
              >
                Xураангуй
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table
              class="table table-bordered"
              id="dataTable"
              width="100%"
              cellspacing="0"
            >
              <thead>
                <tr>
                  <th class="p-0" style="width: 1%">№</th>
                  <th>Name</th>
                  <!-- <th class="p-0 text-right" style="padding-right:2px; font-size:10pt; cursor:pointer" v-for="(lesson, index) in classLessons" v-bind:key="lesson.id" v-bind:title="lesson.name + ': '+ lesson.teachers[0].firstName + ': ' +  lesson.id">   -->
                  <th
                    class="p-0 text-right"
                    style="padding-right: 2px; font-size: 10pt; cursor: pointer"
                    v-for="(lessonCategory, index) in lessonCategoriesInvolvedListData"
                    v-bind:key="lessonCategory.id"
                    v-bind:title="
                      lessonCategory.name + ' : ' + _getCategoryTeachers(lessonCategory)
                    "
                  >
                    {{ index + 1 }}.
                    <span style="font-weight: bold; color: black" @click="_showLesson(lessonCategory)"
                      >{{ _getShortName(lessonCategory.name) }} 
                      <span v-if="lessonCategory.lessons.length > 1" class="text-danger"
                        >({{ lessonCategory.lessons.length }})</span
                      >
                      <!-- <span v-else class="text-success">({{lesson.lessons.length}})</span> --> </span
                    >&nbsp;

                    <span v-if="lessonInfoDetailed" style="display: block">
                      <span
                        class="badge badge-success"
                        style="padding: 2px 4px 2px 4px; margin-right: 2px"
                        v-if="lessonCategory.typeDetail.id == 'zaaval'"
                        >ЗС</span
                      >
                      <span
                        class="badge badge-warning"
                        style="padding: 2px 4px 2px 4px; margin-right: 2px"
                        v-else
                        >СС</span
                      >
                      <!-- <span v-if="" class="badge badge-danger" style="padding:2px 4px 2px 4px; margin-right:2px">Гру</span>
                                            <span class="badge badge-primary" style="padding:2px 4px 2px 4px">Анг</span>   -->
                    </span>

                    <span class="px-1">
                      <span v-for="(less) in lessonCategory.lessons" :key="less.id">
                        <p
                          class="m-0 text-primary golink"
                          style="font-size: 9pt"
                          v-if="isAdmin"
                          @click="
                            $router.push({
                              name: 'ILessonScores',
                              params: { schoolId: schoolId, lessonId: less.id },
                            })
                          "
                          v-bind:title="getXTeacherName(less)"
                        >
                          {{ less.id }},
                        </p>
                        <p class="m-0" v-if="lessonInfoDetailed">
                          {{ getXTeacherName(less) }} 
                        </p>
                      </span>
                    </span>
                    <!-- <p class="m-0" v-for="(less, index) in lesson.lessons"></p> -->
                  </th>
                  <th
                    v-if="calculateSumme"
                    class="text-danger font-weight-bold"
                  >
                    VIII
                  </th>
                  <th
                    v-if="calculateSumme"
                    class="text-danger font-weight-bold"
                  >
                    VII
                  </th>
                  <th
                    v-if="calculateSumme"
                    class="text-danger font-weight-bold"
                  >
                    VI
                  </th>
                  <th
                    v-if="calculateSumme"
                    class="text-danger font-weight-bold"
                  >
                    V
                  </th>
                  <th
                    v-if="calculateSumme"
                    class="text-danger font-weight-bold"
                  >
                    IV
                  </th>
                  <th
                    v-if="calculateSumme"
                    class="text-danger font-weight-bold"
                  >
                    III
                  </th>
                  <th
                    v-if="calculateSumme"
                    class="text-danger font-weight-bold"
                  >
                    II
                  </th>
                  <th
                    v-if="calculateSumme"
                    class="text-danger font-weight-bold"
                  >
                    I
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(student, studentindex) in students" :key="student.id">
                  <td class="p-0">{{ studentindex + 1 }}.</td>
                  <td class="p-0" style="width: 14%">
                    &nbsp;
                    <span
                      v-if="student.lastname && student.lastname.length > 0"
                    >
                      <span
                        v-if="
                          student.lncount &&
                          student.lncount > 1 &&
                          student.lastname.length >= student.lncount
                        "
                        >{{
                          student.lastname.substring(0, student.lncount)
                        }}</span
                      >
                      <span v-else>{{ student.lastname[0] }}</span
                      >.
                    </span>
                    <span style="font-weight: bold; color: #000;font-size:10pt">{{
                      student.name
                    }}</span>
                    <!-- <p>{{student.ref.path}}</p> -->
                    <br />
                  </td>
                  <td
                    v-for="(
                      lessonCategory, lessonindex
                    ) in lessonCategoriesInvolvedListData"
                    
                    class="p-0 text-right score-cell"
                    @click="
                      _callScore(student, lessonCategory, lessonindex, studentindex)
                    "
                    :style="
                      currentChangedLessonIndex == lessonindex &&
                      currentChangedStudentIndex == studentindex
                        ? 'cursor:pointer; color:blue; font-weight:bold'
                        : 'cursor:pointer'
                    "
                    :title="
                      'Сурагч: ' +
                      student.name +
                      ', ' +
                      lessonCategory.name +
                      ', ' +
                      _getCategoryScoreTeacherName(lessonCategory, student, true)
                    "
                  
                    :key="lessonCategory.id"
                  >
                    <!-- v-html="_getCategoryScore(lessonCategory,student,true)" -->
                    <span
                      class="text-danger"
                      v-if="_getCategoryScore(lessonCategory, student, true) == -2"
                      >
                      <!-- дүнгүй -->
                      </span
                    >
                    <span v-else>{{
                      _getCategoryScore(lessonCategory, student, true)
                    }}</span>
                  </td>
                  <td
                    v-if="calculateSumme"
                    class="p-0 text-right font-weight-bold yLevel"
                    v-for="s in _calStudentLevels(student, studentindex)"
                  >
                    {{ s }}
                  </td>
                  <!-- <td v-for="(s,index) in _calLevels(student)">{{s}}</td> -->
                </tr>
                <tr
                  v-if="calculateSumme"
                  v-for="(level, index) in _calLessonLevels()"
                >
                  <td></td>
                  <td
                    class="text-right text-danger xLevel"
                    style="font-weight: bold"
                  >
                    {{ getXRomNumber(level.level) }}
                  </td>
                  <td
                    class="p-0 text-right xLevel"
                    v-for="score in level.scores"
                  >
                    {{ score }}
                  </td>
                  <!-- _calAllStudentLevels -->
                  <td
                    class="yLevel"
                    v-for="(s, sumindex) in _calAllStudentLevels()"
                    v-if="index == sumindex"
                  >
                    {{ s }}
                  </td>
                  <td class="yLevel" v-else></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../../firebaseConfig.js");
import timetable from "../shared/timetable.js";
import myfunction from "../../global/myfunction.js";
export default {
  data() {
    return {
      calculateSumme: false,
      level1: false,
      level2: false,
      level3: false,
      level4: false,
      level5: false,
      level6: false,
      level7: false,
      level8: false,
      showMustHaveLessons: true,
      lessonInfoDetailed: false,
      colored: false,

      debug: false,
      NO_SCORE_FOUND: -2,
      NULL_SCORE_SAVED: -1,
      lessenReduced: true,
      lessonCategoriesInvolved: null,
      lessonCategoriesInvolvedListData: [],
      isAdmin: false,
      classLessons: [],
      loading: false,
      school: null,
      department: null,
      program: null,
      students: [],
      currentSelectedStudent: null,
      lessonCategories: [],
      endCategoryData: [],
      currentChangedLessonIndex: null,
      currentChangedStudentIndex: null,
    };
  },
  mixins: [timetable, myfunction],
  props: {
    schoolId: {
      required: true,
    },
    departmentId: {
      required: true,
    },
    programId: {
      required: true,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  methods: {
    _showLesson(lesson){
      console.log(lesson.lessons)
    },
    async _callScore(student, lesson, lessonindex, studentindex) {
     
    //   this.currentSelectedStudent = student;

    //   var _this = this;
    //   var count = 0;

    //   for (var less of lesson.lessons) {
    //     count++;
    //     console.log(less);
    //     var studentScorePath =
    //       "schools/" +
    //       this.schoolId +
    //       "/students/" +
    //       student.id +
    //       "/finalGrades/" +
    //       less.id;

    //     var scoreRef = await fb.db
    //       .doc(
    //         "schools/" +
    //           this.schoolId +
    //           "/lessons/" +
    //           less.id +
    //           "/studentList/" +
    //           student.id
    //       )
    //       .get();
    //     if (scoreRef.exists) {
    //       this.currentSelectedStudent.newFinalGrade = scoreRef.data();
    //       var yes = confirm(
    //         "Шинэxx дүн олдсон: " +
    //           scoreRef.data().finalScore +
    //           ", Сурагч: " +
    //           student.name +
    //           ", " +
    //           "Багш: " +
    //           this.getXTeacherName(less) +
    //           ": " +
    //           lesson.name
    //       );
    //       if (yes) {
    //         await fb.db
    //           .doc(
    //             "schools/" +
    //               this.schoolId +
    //               "/students/" +
    //               student.id +
    //               "/finalGrades/" +
    //               less.id
    //           )
    //           .set({
    //             createdAt: new Date(),
    //             finalScore: scoreRef.data().finalScore,
    //             semester: "2020-II",
    //           })
    //           .then(() => {
    //             _this.currentChangedLessonIndex = lessonindex;
    //             _this.currentChangedStudentIndex = studentindex;

    //             //_this.currentSelectedLessonIndex = null;
    //             _this.currentSelectedStudent = null;
    //           });
    //       }
    //       break;
    //     } else {
    //       if (count == lesson.lessons.length)
    //         confirm(
    //           "Багш нь дүнгээ оруулаxгүй байж болно. Та багштай нь xолбоо барина уу!"
    //         );
    //     }
    //   }
    },
    _isL8(score) {
      if (score > 90) return true;
      else return false;
    },
    _calLessonLevels() {
      var all = [];
      var list = this._calAllStudentLevelsY();
      var counter = 8;
      for (var k = 0; k < 8; k++) {
        var ss = [];
        for (var j = 0; j < list.length; j++) {
          ss.push(list[j][k]);
        }
        all.push({ level: counter, scores: ss });
        counter--;
      }
      return all;
    },
    _calAllStudentLevelsY() {
      var list = [];
      for (var lessonCategory of this.lessonCategoriesInvolvedListData) {
        list.push(this._calStudentLevelsY(lessonCategory));
      }
      return list;
    },
    _calAllStudentLevels() {
      var l8 = 0,
        l7 = 0,
        l6 = 0,
        l5 = 0,
        l4 = 0,
        l3 = 0,
        l2 = 0,
        l1 = 0;
      for (var student of this.students) {
        var studentLevelScores = this._calStudentLevels(student);
        l8 = l8 + studentLevelScores[0];
        l7 = l7 + studentLevelScores[1];
        l6 = l6 + studentLevelScores[2];
        l5 = l5 + studentLevelScores[3];
        l4 = l4 + studentLevelScores[4];
        l3 = l3 + studentLevelScores[5];
        l2 = l2 + studentLevelScores[6];
        l1 = l1 + studentLevelScores[7];
      }
      return [l8, l7, l6, l5, l4, l3, l2, l1];
    },
    _calStudentLevelsY(lessonCategory) {
      var l8 = 0;
      var l7 = 0;
      var l6 = 0;
      var l5 = 0;
      var l4 = 0;
      var l3 = 0;
      var l2 = 0;
      var l1 = 0;

      for (var student of this.students) {
        var score = this._getCategoryScore(lessonCategory, student, true);
        if (100 >= score && score >= 90) {
          l8++;
          continue;
        } else if (89 >= score && score >= 80) {
          l7++;
          continue;
        } else if (79 >= score && score >= 70) {
          l6++;
          continue;
        } else if (69 >= score && score >= 60) {
          l5++;
          continue;
        } else if (59 >= score && score >= 50) {
          l4++;
          continue;
        } else if (49 >= score && score >= 40) {
          l3++;
          continue;
        } else if (39 >= score && score >= 30) {
          l2++;
          continue;
        } else if (29 >= score && score >= 0) {
          l1++;
          continue;
        }
      }
      return [l8, l7, l6, l5, l4, l3, l2, l1];
    },
    _calStudentLevels(student) {
      var l8 = 0;
      var l7 = 0;
      var l6 = 0;
      var l5 = 0;
      var l4 = 0;
      var l3 = 0;
      var l2 = 0;
      var l1 = 0;

      for (var lessonCategory of this.lessonCategoriesInvolvedListData) {
        var score = this._getCategoryScore(lessonCategory, student, true);
        if (100 >= score && score >= 90) {
          l8++;
          continue;
        } else if (89 >= score && score >= 80) {
          l7++;
          continue;
        } else if (79 >= score && score >= 70) {
          l6++;
          continue;
        } else if (69 >= score && score >= 60) {
          l5++;
          continue;
        } else if (59 >= score && score >= 50) {
          l4++;
          continue;
        } else if (49 >= score && score >= 40) {
          l3++;
          continue;
        } else if (39 >= score && score >= 30) {
          l2++;
          continue;
        } else if (29 >= score && score >= 0) {
          l1++;
          continue;
        }
      }
      return [l8, l7, l6, l5, l4, l3, l2, l1];
    },
    _sortedEndCategoryDataArray: function () {
      function compare(a, b) {
        if (a.index < b.index) return -1;
        if (a.index > b.index) return 1;
        return 0;
      }
      return this.lessonCategoriesInvolvedListData.sort(compare);
    },
    _getScoreTeacherName(lesson, student) {
      for (var c of student.finalScores) {
        if (lesson.id == c[0]) {
          return this.getXTeacherName(lesson); //+ this.isAdmin?':' + lesson.id: lesson.name;
        }
      }
      // return "<span style='background-color:black=; color:white'>"+(-1)+"</span>";;
      return -1;
    },
    _getCategoryScoreTeacherName(lesson, student, category) {
      if (category == false) {
        return this._getScoreTeacherName(lesson, student);
      } else {
        for (var i = 0; i < lesson.lessons.length; i++) {
          var score = this._getScoreTeacherName(lesson.lessons[i], student);
          if (score == -1) continue;
          else return score;
        }
        //return this.NO_SCORE_FOUND;
        return "Дүнгүй учраас багш тодорxойгүй байна.";
      }
    },
    _getCategoryScore(lessonCategory, student, category) {
      if (category == false) {
        return this._getScore(lessonCategory, student);
      } else {
        for (var i = 0; i < lessonCategory.lessons.length; i++) {
          var score = this._getScore(lessonCategory.lessons[i], student);
          if (score == this.NULL_SCORE_SAVED) continue;
          else return score;
        }
        return this.NO_SCORE_FOUND;
        //return "<span class='p-2; font-weight-bold' style='background:#fff1f8; color:red; font-size:9pt'>"+"Дүнгүй"+"</span>"
      }
    },

    _getScore(lesson, student) {
     
      for (var c of student.finalScores) {
        if (lesson.id == c[0]) {
          if (this.colored) {
            if (c[1] == null) return this.NULL_SCORE_SAVED;
            //return "<span class='px-2 bg-danger' style='color:white;font-size:10pt>"+'Дүн татаx'+"</span>";
            else if (c[1] > 91)
              return (
                "<span class='bg-success px-2' style='color:white'>" +
                c[1] +
                "</span>"
              );
            else if (c[1] > 81)
              return "<span class='bg-info px-2'>" + c[1] + "</span>";
            else if (c[1] > 71)
              return (
                "<span class='px-2' style='background:#a0b8ff; color:black'>" +
                c[1] +
                "</span>"
              );
            else if (c[1] > 61)
              return (
                "<span class='px-2' style='background: #ffffd3; color:black'>" +
                c[1] +
                "</span>"
              );
            else
              return (
                "<span class='px-2' style='background:#ffb5ae; color:black;'>" +
                c[1] +
                "</span>"
              );
          } else {
            if (c[1] == null) return this.NULL_SCORE_SAVED;
            //return "<span class='px-2' style='background:yellow; color:red;font-size:10pt'>"+'Дүн татаx'+"</span>";
            else {
              //if(s>89&&this.level8)
              return this.getXEndScore(c, this.level8);
              //else return "<span class='px-2' style='background:#fff; color:white;'>"+c[1]+"</span>";
            }
          }
        }
      }
      // return "<span style='background-color:black=; color:white'>"+(-1)+"</span>";;
      return -1;
    },
    _getCategoryTeachers(category) {
      var str = "";
      var count = 0;
      for (var lesson of category.lessons) {
        str =
          count == 0
            ? this.getXTeacherName(lesson)
            : str + ", " + this.getXTeacherName(lesson);
        count++;
      }
      return str + "(" + category.lessons.length + ")";
    },
    _exitsCategory(categoryDoc, lesson) {
      var foundData = null;
      for (var i = 0; i < this.lessonCategoriesInvolvedListData.length; i++) {
        var data = this.lessonCategoriesInvolvedListData[i];
        if (data.id == categoryDoc.id) {
          foundData = data;
          break;
        }
      }
      if (foundData == null) {
        let foundData = categoryDoc.data();
        foundData.id = categoryDoc.id;
        foundData.ref = categoryDoc.ref
        foundData.lessons = [];
        foundData.lessons.push(lesson);
        this.lessonCategoriesInvolvedListData.push(foundData);
      } else {
        foundData.lessons.push(lesson);
      }
      return foundData;
    },
    async _findCategory(schoolId, lesson) {
      var _this = this;
      var catRef = fb.db
        .collection("schools/" + schoolId + "/categories")
        .doc(lesson.category.id);
      await catRef
        .get()
        .then(function (doc) {
           
          lesson.categoryTypeId = doc.data().typeDetail.id;
          lesson.categoryTypeName = doc.data().typeDetail.name;
          lesson.categoryData = doc.data();
          lesson.categoryId = doc.id;
          lesson.categoryRef = doc.ref
          let categoryData = doc.data();
          categoryData.id = doc.id;
          _this.lessonCategoriesInvolved.add(categoryData.id);
          _this._exitsCategory(doc, lesson);
        })
        .catch(function (error) {
          console.log("Error getting cached document:", error);
        });
    },
    async _getLessons() {
      var query = fb.db
        .collection("schools/" + this.schoolId + "/lessons")
        .where(
          "programs",
          "array-contains",
          fb.db.doc(
            "/schools/" +
              this.schoolId +
              "/departments/" +
              this.departmentId +
              "/programs/" +
              this.programId
          )
        );

      if (query != null) {
        var lessonsDatas = await query.get();
        for (const doc of lessonsDatas.docs) {
          let lesson = doc.data();
          lesson.id = doc.id;
          lesson.procent = 0;
          lesson.ref = doc.ref;
          if (lesson.category && lesson.category.id) {
            await this._findCategory(this.schoolId, lesson);
          }

          if (
            lesson &&
            lesson.numberOfUnderstand &&
            lesson.numberOfTotalStatus
          ) {
            lesson.procent = (
              (lesson.numberOfUnderstand * 100) /
              lesson.numberOfTotalStatus
            ).toFixed(2);
          }

          //await this._isLessonTobeRemoved(lesson);
          this.classLessons.push(lesson);
        }
      }
      // await this._sortedArray(this.classLessons);
      // await this._readArray();
      this._sortedEndCategoryDataArray();
    },
    async _readStudentGrades(collectionName, student) {
        // /schools/xUSN7smB3EcLwDYhs1Y9/students
        // "schools/" +  this.schoolId +"/students/" + this.student.id + "/finalGrades";
      fb.db
        .collection(collectionName + "/" + student.id + "/finalGrades")
        .onSnapshot((querySnapshot) => {
          student.finalScores = [];
          querySnapshot.forEach((doc) => {
            let scoreData = doc.data();
            scoreData.id = doc.id;
            scoreData.ref = doc.ref
            if(scoreData!=undefined&&scoreData.scores!=undefined)
              student.finalScores.push([
                scoreData.id,
                scoreData.scores[0].finalScore,
              //   this.getXLevel(scoreData.finalGrades),
              ]);
          });
        });
    },
    async _getProgramStudents(collectionName, program) {
      fb.db
        .collection(collectionName)
        .where("program-"+this.school.currentYear, "==", program.ref)
        .orderBy("name", "asc")
        .get()
        .then((querySnapshot) => {
          this.students = [];
          querySnapshot.docs.forEach(async (doc) => {
            if (doc.exists) {
              let student = doc.data();
              student.id = doc.id;
              student.ref = doc.ref;
              student.finalScores = [];
              this._readStudentGrades(collectionName, student);
              this.students.push(student);
            }
          });
        });
    },
    async _getSchool(schoolId) {
      var schoolDoc = await fb.db.doc("schools/" + schoolId).get();
      if (schoolDoc.exists) {
        let school = schoolDoc.data();
        school.id = schoolDoc.id;
        school.ref = schoolDoc.ref;
        this.school = school;
        return this.school;
      }
      return null;
    },
    async _getDepartment(schoolId, departmentId) {
      var departmentDoc = await fb.db
        .doc("schools/" + schoolId)
        .collection("departments")
        .doc(departmentId)
        .get();
      if (departmentDoc.exists) {
        let department = departmentDoc.data();
        department.id = departmentDoc.id;
        department.ref = departmentDoc.ref;
        this.department = department;
      }
    },
    async _getProgram(schoolId, departmentId, programId) {
      var programDoc = await fb.db
        .doc("schools/" + schoolId)
        .collection("departments")
        .doc(departmentId)
        .collection("programs")
        .doc(programId)
        .get();
      if (programDoc.exists) {
        let program = programDoc.data();
        program.id = programDoc.id;
        program.ref = programDoc.ref;
        this.program = program;
      }
    },
    async _initData() {
      this.loading = true;
      var startTime = new Date().getTime();
      this.school = await this._getSchool(this.schoolId);
      this._getDepartment(this.schoolId, this.departmentId);
      await this._getProgram(this.schoolId, this.departmentId, this.programId);
      await this._getProgramStudents(
        "/schools/xUSN7smB3EcLwDYhs1Y9/students",
        this.program
      );
      await this._getLessons();
 
      this.loading = false;
    },
    _changeLessonMetaInfo() {
      this.lessonInfoDetailed = !this.lessonInfoDetailed;
    },
    _changeColored() {
      this.colored = !this.colored;
    },
    _getTableHeader() {
      var header = [1];
      for (var lesson of this.lessonCategoriesInvolvedListData) {
        header.push(
          lesson.typeDetail.id == "zaaval"
            ? lesson.name + ""
            : lesson.name + "(СС)"
        );
      }

      for (var k of [1, 2, 3, 4, 5, 6, 7, 8]) {
        header.push(this.getXRomNumber(k));
      }
      return header;
    },
    _getTableBody() {
      var bodyData = [];
      for (var i = 0; i < this.students.length; i++) {
        var row = [];
        row.push(this.students[i].name);

        for (var lesson of this.lessonCategoriesInvolvedListData) {
          //row.push(this._getCategoryScore(lesson,student,true));
          var x = this._getCategoryScore(lesson, this.students[i], true);
          if (x == -2) row.push(null);
          else row.push(x);
        }

        for (var xScore of this._calStudentLevels(this.students[i], i)) {
          row.push(xScore);
        }
        bodyData.push(row);
      }
      var level = this._calLessonLevels();
      for (var i = 0; i < level.length; i++) {
        var row1 = [];
        row1.push(this.getXRomNumber(level[i].level));
        for (var score of level[i].scores) {
          row1.push(score);
        }
        //summe
        var summes = this._calAllStudentLevels();
        for (var j = 0; j < summes.length; j++) {
          if (i == j) row1.push(summes[j]);
          else row1.push(0);
        }
        bodyData.push(row1);
      }
      return bodyData;
    },
    handleDownload() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then((excel) => {
        const tHeader = this._getTableHeader();
        const data = this._getTableBody();
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename:
            this.department.name + this.program.name + "_2020_жилийн_эцсийн_дүнгийн_xавтгай",
          autoWidth: true,
          bookType: this.bookType,
        });
        this.downloadLoading = false;
      });
    },
  },
  created() {
    if (this.userProfile && this.userProfile.role == "admin")
      this.isAdmin = true;

    this.classLessons = [];
    this.lessonCategoriesInvolved = new Set();
    this._initData();
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>
<style scoped>
.score-cell:hover {
  /* background-color:#f0f6ff; */
  background-color: #fff3cd;
  border: 3px solid red;
  cursor: pointer;
  color: black;
}
.golink:hover {
  text-decoration: underline;
}
.xLevel {
  font-weight: bold;
  background-color: #ffffad;
  color: black;
}
.yLevel {
  font-weight: bold;
  background-color: #d3f7d8;
  color: black;
}
.scoreNotFound {
  background-color: #ee1717;
  color: black;
  color: white;
}
</style>
